import { QueryKey, UseQueryOptions } from 'react-query';
import { AssetQueryOptions } from '../titles/queries';
import { getRecordingAsset, getRecordings } from './api';
import { recordingAssetKey, recordingsKey } from './keys';
import { Recording } from './types/recording';

export interface RecordingsQueryOptions<T = Recording[]> extends UseQueryOptions<Recording[], unknown, T, QueryKey> {}

export function recordingsQuery<T = Recording[]>(options?: RecordingsQueryOptions<T>) {
  return { queryKey: recordingsKey(), queryFn: () => getRecordings(), ...options } as const;
}

export interface RecordingAssetQueryOptions extends AssetQueryOptions {
  type: 'single' | 'series';
}

export function recordingAssetQuery({ id, enabled, ...options }: RecordingAssetQueryOptions) {
  return {
    queryKey: recordingAssetKey(id, options),
    queryFn: () => getRecordingAsset(id, options),
    enabled,
    retry: false,
  } as const;
}
